module.exports = __webpack_public_path__ + "static/beach-ball-bdd8f0d241531ad0d0bb18eece19c226.png";